import {Component} from '@angular/core';
import {ModalService} from '../modal/modal.service';

@Component({
    selector: 'app-confirm',
    template: `
        <app-modal id="confirmation-modal" class="modal fade show">
            <div class="modal-body text-center">
                <h6>{{ 'Modal.ConfirmQuestion' | translate }}</h6>
            </div>
            <div class="modal-footer btn-group btn-group--center">
                <button type="button" class="btn btn--default ml-rtl" (click)="no()">{{ 'Modal.Cancel' | translate }}</button>
                <button type="button" class="btn btn--primary mr-rtl" (click)="yes()">{{ 'Modal.Delete' | translate }}</button>
            </div>
        </app-modal>
    `
})

export class ConfirmationModalComponent {

    constructor(private modalService: ModalService) {
    }

    yes() {
        this.modalService.isSubmit.next(true);
        this.modalService.close('confirmation-modal');
    }

    no() {
        this.modalService.isSubmit.next(false);
        this.modalService.close('confirmation-modal');
    }
}
